import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/layout/Layout'
import HealthPanel from './components/panels/HealthPanel'
import EntitiesPanel from './components/panels/EntitiesPanel'
import JournalPanel from './components/panels/JournalPanel'
import MaintenancePanel from './components/panels/MaintenancePanel'
import WakePanel from './components/panels/WakePanel'
import RelationalArcPanel from './components/panels/RelationalArcPanel'
import SparrowOpsPanel from './components/panels/SparrowOpsPanel'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/health" replace />} />
        <Route path="health" element={<HealthPanel />} />
        <Route path="entities" element={<EntitiesPanel />} />
        <Route path="journal" element={<JournalPanel />} />
        <Route path="maintenance" element={<MaintenancePanel />} />
        <Route path="wake" element={<WakePanel />} />
        <Route path="relational" element={<RelationalArcPanel />} />
        <Route path="sparrow" element={<SparrowOpsPanel />} />
      </Route>
    </Routes>
  )
}
